<template>
  <div>
    <slot v-bind="{ toggleItem, isExpanded }"></slot>
  </div>
</template>
<script>
export default {
  data() {
    return {
      openedItem: null
    };
  },
  methods: {
    toggleItem(id) {
      if (this.openedItem === null) {
        this.openedItem = id;
      } else if (this.openedItem === id) {
        this.openedItem = null;
      } else {
        this.openedItem = id;
      }
    },
    isExpanded(id) {
      return id === this.openedItem;
    }
  }
};
</script>

<style lang="scss"></style>
